var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"homepage"},[_c('el-container',{staticClass:"all"},[_c('left'),_c('el-container',{staticClass:"cow"},[_c('el-header',{staticStyle:{"height":"auto","padding":"0"}},[_c('right')],1),_c('el-main',[_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }